import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { LISTADOS, irADetalleCobro } from './definiciones';
import { registrarAltaCobro } from '../../services/cobranzaService';
import TablaListado from '../../components/Listados/TablaListado';
import AccesosListados from '../../components/Listados/AccesosListados';
import ModalDetalleCobro from '../../components/Cobranzas/ModalDetalleCobro';
import PageHeader from '../../components/ui/PageHeader';

const DEF = LISTADOS.aCobrar;

/**
 * Favorables. Desde la fila se pasa a Altas (pedido del estudio, oct-2026): se carga la fecha de alta
 * —el día que va a cobrar, que publica ANSES— y el cobro pasa al listado de Altas. Sin fecha por
 * defecto: el alta no es el día en que se carga (24-oct-2026).
 */
export default function ListadoACobrar() {
    const navigate = useNavigate();
    const [idCobroAbierto, setIdCobroAbierto] = useState(null);
    const [recargarToken, setRecargarToken] = useState(0);
    const [paraAlta, setParaAlta] = useState(null);
    const [fechaAlta, setFechaAlta] = useState('');
    const [guardando, setGuardando] = useState(false);

    const abrirAlta = (row) => {
        setFechaAlta('');
        setParaAlta(row);
    };

    const confirmarAlta = async () => {
        if (!fechaAlta) {
            toast.error('Elegí la fecha de alta.');
            return;
        }
        setGuardando(true);
        try {
            await registrarAltaCobro(paraAlta.idCobro, fechaAlta);
            toast.success('Pasado a Altas.');
            setParaAlta(null);
            setRecargarToken((t) => t + 1);
        } catch (err) {
            toast.error(err.response?.data?.mensaje || 'No se pudo registrar el alta.');
        } finally {
            setGuardando(false);
        }
    };

    const columnas = useMemo(() => [...DEF.columnas, {
        key: 'pasarAAltas', header: 'Altas',
        render: (row) => (
            <button
                type="button"
                className="btn btn-sm btn-outline-success rounded-pill text-nowrap"
                onClick={(e) => { e.stopPropagation(); abrirAlta(row); }}
                title="Ya cobra el beneficio: registrar el alta"
            >
                <i className="bi bi-check2-circle me-1" />Pasar a Altas
            </button>
        ),
    }], []);

    const nombre = paraAlta ? [paraAlta.apellido, paraAlta.nombre].filter(Boolean).join(', ') : '';

    return (
        <div className="container-fluid mt-4 listado-pagina area-cobranzas">
            <PageHeader
                variante="plano"
                icono={DEF.icono}
                titulo={DEF.titulo}
                descripcion={DEF.subtitulo}
            />

            <AccesosListados actual={DEF.clave} />

            <TablaListado
                claveFiltro="listadoACobrar"
                columnas={columnas}
                fetchPage={DEF.fetchPage}
                onRowClick={(row) => irADetalleCobro(row, navigate, setIdCobroAbierto)}
                rowKey={(row) => row.idCobro}
                dependencias={[recargarToken]}
            />

            <ModalDetalleCobro
                open={!!idCobroAbierto}
                idCobro={idCobroAbierto}
                onClose={() => setIdCobroAbierto(null)}
                onCambio={() => setRecargarToken((t) => t + 1)}
            />

            <Modal className="rec-modal" show={!!paraAlta} onHide={() => setParaAlta(null)} centered>
                <Modal.Header closeButton>
                    <Modal.Title><i className="bi bi-check2-circle me-2" />Pasar a Altas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {nombre && <p className="fw-semibold mb-3">{nombre}</p>}
                    <label className="form-label fw-semibold" htmlFor="favorables-fecha-alta">Fecha de alta (cuándo va a cobrar)</label>
                    <input id="favorables-fecha-alta" type="date" className="form-control"
                        value={fechaAlta} onChange={(e) => setFechaAlta(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <button className="rec-btn-secondary" onClick={() => setParaAlta(null)} disabled={guardando}>Cancelar</button>
                    <button className="rec-btn-primary" onClick={confirmarAlta} disabled={guardando}>
                        {guardando ? 'Guardando…' : 'Pasar a Altas'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
